import { render, staticRenderFns } from "./productCenTil.vue?vue&type=template&id=774c9454&scoped=true&"
import script from "./productCenTil.vue?vue&type=script&lang=js&"
export * from "./productCenTil.vue?vue&type=script&lang=js&"
import style1 from "./productCenTil.vue?vue&type=style&index=1&id=774c9454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c9454",
  null
  
)

export default component.exports